/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    SUBSCRIPTIONS_RECEIVE,
    SUBSCRIPTIONS_REQUEST,
    SUBSCRIPTIONS_REQUEST_SUCCESS,
    SUBSCRIPTIONS_REQUEST_FAILURE,
    CURRENT_SUPPORT_RECEIVE,
    CURRENT_RENTAL_RECEIVE,
    CURRENT_RETAILER_RENTAL_RECEIVE,
    CURRENT_CLOUD_HOSTING_RECEIVE,
    CURRENT_DISPATCH_RECEIVE,
    CURRENT_VISUALDECK_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [CURRENT_SUPPORT_RECEIVE]: (state, action) => {
        return reduce(
            [action.payload.support],
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
    [CURRENT_RENTAL_RECEIVE]: (state, action) => {
        return reduce(
            [action.payload.rental],
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
    [CURRENT_RETAILER_RENTAL_RECEIVE]: (state, action) => {
        return reduce(
            [action.payload.retailerRental],
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
    [SUBSCRIPTIONS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
    [CURRENT_CLOUD_HOSTING_RECEIVE]: (state, action) => {
        return reduce(
            [action.payload.hosting],
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
    [CURRENT_DISPATCH_RECEIVE]: (state, action) => {
        return reduce(
            [action.payload.dispatchplan],
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
    [CURRENT_VISUALDECK_RECEIVE]: (state, action) => {
        return reduce(
            [action.payload.visualdeck],
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [SUBSCRIPTIONS_REQUEST]: () => true,
    [SUBSCRIPTIONS_REQUEST_SUCCESS]: () => false,
    [SUBSCRIPTIONS_REQUEST_FAILURE]: () => false,
});

export const error = createReducer(false, {
    [SUBSCRIPTIONS_REQUEST]: () => false,
    [SUBSCRIPTIONS_REQUEST_SUCCESS]: () => false,
    [SUBSCRIPTIONS_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
